import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ProgramClassificationDataTable from '../../../../components/datatables/postSecondary/ProgramClassificationDataTable';
import Breadcrumbs from '../../../../config/Breadcrumbs';
import Routes from '../../../../config/Routes';
import HeaderPortal from '../../../../portals/HeaderPortal';
import HistoryUtil from '../../../../utils/HistoryUtil';

interface ProgramClassificationListProps {
}

interface ProgramClassificationListState {
}

class ProgramClassificationListPage extends React.Component<ProgramClassificationListProps & RouteComponentProps<RouteObject>, ProgramClassificationListState> {
  constructor(props: ProgramClassificationListProps & RouteComponentProps<RouteObject>) {
    super(props);
  }

  private goToConfig = () => {
    HistoryUtil.push(Routes.generate(Routes.CONFIGURATIONS));
  }

  render() {
    return (
      <Content>
        <HeaderPortal title="Program Classification" onBack={this.goToConfig} breadcrumbs={Breadcrumbs.programClassificationList()} />

        <Card >
          <ProgramClassificationDataTable />
        </Card>
      </Content>
    );
  }
}

export default withRouter(ProgramClassificationListPage);
